import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ItemPedido } from 'src/app/models/pedido';

@Component({
  selector: 'app-produtos-selecionados-modal',
  templateUrl: './produtos-selecionados-modal.component.html',
  styleUrls: ['./produtos-selecionados-modal.component.scss']
})
export class ProdutosSelecionadosModalComponent implements OnInit {
  itensSelecionados: ItemPedido[] = [];
  itensParaExcluir: ItemPedido[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<ProdutosSelecionadosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.itensSelecionados = data.itensSelecionados;
  }

  ngOnInit() {
  }

  excluir(item: ItemPedido) {
    //this.itensSelecionados.splice(this.itensSelecionados.indexOf(item), 1);
    //item.checado = false;
    //item.qt = undefined;
    this.itensParaExcluir.push(item);
  }

  fechar() {
    this.dialogRef.close(this.itensParaExcluir);
  }

  itensParaMostrar() {
    return this.itensSelecionados.filter(p => !this.itensParaExcluir.some(e => e === p));
  }

}
